/**
 * Formats number of seconds into hh:mm:ss
 * @param {number} sec
 * @returns {string}
 */
export const formatDuration = (sec) => {
  // TODO (noahlaux): We would like to transition to Number.isNaN, but we have too much view logic
  // depending on how the window.isNaN implementation works
  // eslint-disable-next-line no-restricted-properties
  if (window.isNaN(sec) || sec < 0) {
    return ''
  }

  const time = Math.round(sec)

  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time % 60

  let timeString = ''
  if (hours) {
    timeString = `${hours < 10 ? '0' : ''}${hours}:`
  }
  timeString = `${timeString}${minutes < 10 ? '0' : ''}${minutes}:`
  timeString = `${timeString}${seconds < 10 ? '0' : ''}${seconds}`

  return timeString
}

export const parseUTCUnixSecondsTime = (timeString) => {
  const utcDateSeconds = new Date(new Date().toUTCString()) / 1000
  return utcDateSeconds - timeString
}
